// @flow
import config from '../../config';
import { makeAPICall, APIError, redirectTo } from '../generalCreators';
import { updateCurrentInsightSet } from './currentInsightSetCreators';
import type {
  ThunkAction,
  InsightSet,
  UpdateGloablInsightsets
} from '../../types';

export function getInsightSets(
  organisationId: ?number = undefined,
  isAllocatedTo: boolean = true,
  excludeArchived: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/insightsets';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        excludeArchived
      }
    };

    if (organisationId) {
      options.params = {
        ...options.params,
        organisationId,
        isAllocatedTo
      };
    }

    return makeAPICall(endpoint, options).then(
      data => dispatch(updateInsightSets(data.data.insightSets)),
      error => dispatch(APIError(error, 'Error getting InsightSets'))
    );
  };
}

export function updateInsightSets(
  insightSets: InsightSet[]
): UpdateGloablInsightsets {
  return {
    type: 'UPDATE_GLOBAL_INSIGHTSETS',
    insightSets
  };
}

export function getInsightSet(
  insightSetId: number,
  withSettings: boolean = true
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/insightset/${insightSetId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        withSettings
      }
    };

    return makeAPICall(endpoint, options).then(
      response => response.data,
      error => dispatch(APIError(error, 'Error getting InsightSet'))
    );
  };
}

export function addInsightSet(insightSet: InsightSet): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/insightsets';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: insightSet
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const newInsightSetId = response.data.id;
        dispatch(getInsightSets());
        dispatch(updateCurrentInsightSet(newInsightSetId));
        redirectTo(`/insight-sets/${newInsightSetId}`);
        return response;
      },
      error => dispatch(APIError(error, 'Error creating InsightSet'))
    );
  };
}

export function updateInsightSet(insightSet: InsightSet): ThunkAction {
  return function(dispatch, getState) {
    if (!insightSet.id) {
      return dispatch(
        APIError(new Error('No insight set id'), 'Error updating InsightSet')
      );
    }
    const endpoint = `/insightset/${insightSet.id}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: insightSet
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getInsightSets());
        dispatch(updateCurrentInsightSet(insightSet.id));
        return response;
      },
      error => dispatch(APIError(error, 'Error updating InsightSet'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/insightSets/basicCreators.js